let initialState = {
  status: false,
  pendingCount: 0,
  sidebarShow: 'responsive',
};
let globalLoading = (state = initialState, action) => {
  switch (action.type) {
    case 'CONTROL_LOADING':
      return {...state, status: action.status};
    case 'GLOBAL_LOADING_START':
      return {...state, pendingCount: state.pendingCount + 1};
    case 'GLOBAL_LOADING_END':
      return {...state, pendingCount: Math.max(0, state.pendingCount - 1)};
    case 'set':
      return {...state, sidebarShow: action.sidebarShow};
    default:
      return state;
  }
};

export const selectIsGlobalLoading = (state) =>
  state.globalLoading.status || state.globalLoading.pendingCount > 0;

export default globalLoading;
